import { render, staticRenderFns } from "./blogView.vue?vue&type=template&id=10b72cce"
import script from "./blogView.vue?vue&type=script&lang=js"
export * from "./blogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports